module.exports = __webpack_public_path__ + "static/media/camera.6b3e4335.gif";